import React, {useEffect,useState,useMemo,useContext } from "react";
import { BORDER, USERTYPES } from "../../constants/Constants";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getExpandedRowModel,
  createRow,
  expandRows,
  RowSelection,
} from "@tanstack/react-table";
import "../ListViewV2/ListViewStylesV2.css";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import ListViewPagination from "../ListViewV2/ListViewPagination";
import themeContext from "../../context/theme/ThemeContext";
import ShimmerStudyRows from "../../pages/StudyList/components/ShimmerStudyList/ShimmerStudyRows";
import LoadingBar from "react-top-loading-bar";

const ListViewTableV3 = (props) => {

  const { getThemeColor} = useContext(themeContext);
  const queryClient = useQueryClient();
  const [rowSelection, setRowSelection] = useState({});
  const [expanded, setExpanded] = useState({});
  const pageIndex = props.pageIndex;
  const pageSize = props.pageSize;
  const setActiveQuery = props.setActiveDataQuery != null && props.setActiveDataQuery != undefined ? true : false;
  const dataQueryState = props.dataQueryState;
  const setDataQueryState = props.setDataQueryState;
  const [arrayPageIndex, setArrayPageIndex] = useState([]);
  const defaultData = useMemo(() => [], []);
  const columns = props.columns;
  const sortObj = props.sortObj;
  const filterObj = props.filterObj;
  const uniqueKey = props.uniqueKey === undefined ? "" : props.uniqueKey;
  const showSideBySide = props.showSideBySide;
  const fullLength = props.fullLength;
  const fullLengthForRow = props.fullLengthForRow;
  const pointer = props.pointer != undefined && props.pointer != null ? props.pointer: true;

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  );

    
 const fetchDataOptions = {
  page: pageIndex,
  pageSize: pageSize,
  sortObj,
  filterObj,
  uniqueKey
}

  const dataQuery = useQuery({
    queryKey: ["data", fetchDataOptions],
    queryFn: () => props.fetchData(fetchDataOptions),
    keepPreviousData: true,
    staleTime: Infinity, // Set stale time to 5 minutes
    gcTime: 15 * 60 * 1000, // Set cache time to 5 minutes
    initialData: () => {
      return queryClient.getQueryData(["data"]);
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["data"])?.dataUpdatedAt,
  });


  useEffect(() => {
    let currentPageNumber = pageIndex;
    let totalPageNumber = dataQuery.data?.pageCount;
    handlePaginationAlgo(currentPageNumber, totalPageNumber);
    if(setActiveQuery){
      props.setActiveDataQuery(dataQuery);
    }
  }, [
    dataQuery.data?.pageCount,
    pageIndex + 1,
    pageSize,
    dataQuery.data,
  ]);
  useEffect(() => {
    if (dataQuery != undefined && dataQuery != null) {
      setDataQueryState(dataQuery);
    }
  }, [pageIndex, pageSize, sortObj]);

  useEffect(() => {
    if (dataQuery.isFetched) {
      setDataQueryState(dataQuery);
    }
  }, [dataQuery.isFetched, dataQuery.isFetching]);


    const table = useReactTable({
      data: dataQueryState?.data?.rows ?? defaultData,
      columns: columns,
      pageCount: dataQueryState?.data?.pageCount ?? -1,
      state: {
        pagination,
        rowSelection,
        expanded,
      },
      onPaginationChange: props.setPagination,
      onRowSelectionChange: setRowSelection,
      getCoreRowModel: getCoreRowModel(),
      // getExpandedRowModel: getExpandedRowModel,
      // getExpandedRowModel: (row) => fetchPriorsData(row),
      onExpandedChange: setExpanded,
      manualPagination: true,
      manualExpanding: true,
      // getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
      debugTable: true,
    });

    const handlePaginationAlgo = (
      currentPageNumber,
      totalPageNumber,
      offset = 2
    ) => {
      currentPageNumber = currentPageNumber+1;
      const offsetNumber =
        currentPageNumber <= offset ||
        currentPageNumber > totalPageNumber - offset
          ? offset
          : offset - 1;
      const numbersList = [];
      const numbersListWithDots = [];
      console.log("--- Pages are ---",totalPageNumber);
      // If itemsPerPage is less than what the user selected with the Select component or if there is no page or only one page:
      if (totalPageNumber <= 1 || totalPageNumber === undefined) return setArrayPageIndex([1]);
      // Create list of numbers:
      numbersList.push(1);
      for (
        let i = currentPageNumber - offsetNumber;
        i <= currentPageNumber + offsetNumber;
        i++
      ) {
        if (i < totalPageNumber && i > 1) {
          numbersList.push(i);
        }
      }
      numbersList.push(totalPageNumber);
  
      // Add three dots to the list of numbers:
      numbersList.reduce((accumulator, currentValue) => {
        if (accumulator === 1) {
          numbersListWithDots.push(accumulator);
        }
        if (currentValue - accumulator !== 1) {
          numbersListWithDots.push("......");
        }
        numbersListWithDots.push(currentValue);
        return currentValue;
      });
      console.log("--- Final Page Indexes ---",numbersListWithDots);
      setArrayPageIndex(numbersListWithDots);
    };

    
    const setSelectedRowFunction = (cell) => {
      console.log("Row is ");
      console.log(cell);
      // cell.original["index"] = cell.index;
      props.handleUserClick(cell);
    };

    const getHeightOfContainer = () => {
      if(props.showPagination == false){
        return "calc(100% - 50px)"
      }
      if(props.tabHeaderPresent){
        return "calc(100% - 101px)";
      }else{
        return "calc(100% - 155px)"
      }
    }

    return (
     <>
      {props.listViewLoading && <>
        <div
          className="main-container-list-view-v3"
          style={{
            padding: "auto",
            // height: "100%",
            width: "100%",
            zIndex: "99999",
            display: `${props.listViewLoading ? "flex" : "none"}`,
            flexDirection: "column",
            justifyContent: "center",
            overflow: "auto",
            alignItems: "center",
            backgroundColor: "black",
            opacity: "0.4",
            // position: "absolute",
            // top: "0",
            // left: "0",
            height: getHeightOfContainer(),borderTop:getThemeColor("border")
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            <ShimmerStudyRows />
          </div>

          <LoadingBar
            ref={props.listViewRef}
            color="#0085FF"
            height={5}
            // progress={progress}
            onLoaderFinished={() => {props.setListViewLoading(false)}}
            containerStyle={{
              backgroundColor: "black",
              opacity: "0.8",
              position: "absolute",
              bottom: "calc(100% - 222px)",
              left: "65px",
              top: "unset"
            }}
            loaderSpeed={1000}
            transitionTime={1000}
          />
        </div>
      </>}

         {!props.listViewLoading && <>
        <div className="main-container-list-view-v3" style={{height: getHeightOfContainer(),
          // borderTop:getThemeColor("border")
          }}>
          <div className="parent-list-view-v3" style={{width:showSideBySide?"30%":"100%"}}>
            <div
              className="child-1-list-view"
              style={{ width: isMobile ? "100%" : "100%"}}
            >
        <table
              className="list-view-table"
            >
            {!showSideBySide && <thead style={{borderTop:getThemeColor("border")}} className={`${!isMobile ? "list-view-thead" : ""}`}>
                {table.getHeaderGroups().map((headerGroup, index) => (
                  <tr className="list-view-thead-tr" style={{width:(fullLength && fullLengthForRow)?"100%":"unset"}} key={index}>
                    {headerGroup.headers.map((header, index) => {
                      return (
                        <React.Fragment key={index}>
                          {header.column.columnDef.show == true && (
                            <th
                              
                              key={index}
                              colSpan={header.colSpan}
                              style={header.column.columnDef.headerStyle}
                              className={header.column.columnDef.headerClass}
                            >
                              {header.isPlaceholder ? null : (
                                  flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                  )
                              )}
                            </th>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tr>
                ))}
              </thead>}
              <tbody className={`${
                    !isMobile ? "list-view-tbody modal-scroll" : "list-view-tbody modal-scroll"
                  }`} style={{ verticalAlign: "top" }}>
                {table?.getRowModel().rows?.map((row, trIndex) => {
                  return (
                    <React.Fragment key={trIndex}>
                      <tr
                        className={`${!isMobile ? `list-view-tr  ${pointer?"cursor-pointer":""} hover-list-view-tr` : ""} ${
                          trIndex % 2 == 0
                            ? "tr-alternative-color"
                            : "tr-second-alternative-color"
                        } ${trIndex != 0 ? "list-view-border":""}`}
                        style={{
                          backgroundColor:(showSideBySide && trIndex === props.selectedRow) ?getThemeColor("active-side-tab"):showSideBySide?"unset":"",
                          width:fullLength?"100%":"unset"
                        }}
                          // onDoubleClick={() => {
                        //   if (props.roles[0] != USERTYPES.FIRMTECHNICIAN)
                        //     handleStudyRowDoubleClick(row);
                        // }}
                      >
                        {row.getVisibleCells().map((cell, index) => {
                          return (
                            <React.Fragment key={index}>
                              {cell.column.columnDef.show == true && (
                                <td
                                onClick={() => setSelectedRowFunction(cell)}
                                  style={
                                    cell.column.columnDef.style != undefined
                                      ? cell.column.columnDef.style
                                      : {}
                                  }
                                  className={` ${
                                    cell.column.columnDef.className != undefined
                                      ? cell.column.columnDef.className
                                      : ""
                                  }`}
                                  key={index}
                                >
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}
                                </td>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tr>
                      
                    </React.Fragment>
                  );
                })}
              </tbody>
              {(dataQuery.data === undefined || dataQuery.data?.rows?.length == 0) && (
                <tbody style={{ verticalAlign: "top" }}>
                  <tr>
                    <td>
                      <div className="study-list-spinner">
                        <span className="study-list-no-data-txt">
                          No Data Found (Please clear any applied filters)
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
            </div>
            </div>
          {showSideBySide && dataQuery.data?.rows?.length > 0 && <div className="list-view-detail-section-v3">
            {props.selectedRowComponent}
            </div>  }
          </div>
            {dataQuery.isFetched && props.showPagination && (
        <>
          <ListViewPagination
            table={table}
            arrayPageIndex={arrayPageIndex}
            pageIndex={pageIndex}
            pageSize={pageSize}
            pagination={pagination}
          />
        </>
      )}
        </>}
        </>
    )
}

export default ListViewTableV3;